import ExaminationLayout from './ExaminationLayout';

export default ExaminationLayout;
